export const createId = () => {
  return Math.random().toString(36).substr(2, 10);
};

export const createObj = () => {
  return {
    id: createId(),
    operation: null, // 标签规则运算符, > < =
    operationValue: null, // 标签运算需要的数值 > < = 对应的值
    operationAnd: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等
    operationAndValue: null, // 标签运算符，'计算类型为，相对的时候所用' 过去、将来、至过去等对应的值
    operationType: null, // 标签运算类型 1-绝对的 2-相对的 3-有值 4-无值
    outsideSort: null, //用于排序
    profileTagCollectionId: null, //集合标签单中个标签物理ID
    profileTagId: null, // 标签物理ID
    type: null, //标签规则类型 1-包含 2-排除
    tagIds: null, // 标签规则所选字段ID
    valueType: null, // 类型 1-文本输入 2-下拉框 3-日期类型 4-日期时间类型
    withinSort: null, // 标签规则'且'集合的排序
    collectArr: [],
    originalDataType: 1,
  };
};
// 每条新增原始数据
export const createPersonObj = () => {
  return {
    id: createId(),
    tagIds: null,
    originalDataType: 2,
  };
};
//初始化详细设定数据结构
export const initDetailForm = () => {
  return {
    id: createId(),
    tagCollectionRuleIn: [],
    tagCollectionRuleOut: [],
  };
};

export const tagDomeItem = () => {
  return {
    originalDataType: 1,
    id: createId(),
    originalDataList: [createObj()],
  };
};

//标签
export const tagDom = () => {
  return [tagDomeItem()];
};

export const personDomItem = () => {
  return {
    originalDataType: 2,
    id: createId(),
    originalDataList: [createPersonObj()],
  };
};
//人群
export const personDom = () => {
  return [personDomItem()];
};

export const initValueFieldIds = (ids, list) => {
  let data = [];
  const init = (pIds, pList) => {
    if (pIds.length > 0) {
      for (let i = 0; i < pIds.length; i++) {
        const d = pList.find((item) => item.id === pIds[i]);
        if (d) {
          data.push(d);
          const fIds = pIds.filter((it) => it !== pIds[i]);
          fIds.length > 0 && init(fIds, d.children);
          break;
        }
      }
    }
  };
  init(ids, list);
  return data;
};

export const getDicList = (value, dicObj) => {
  if (value && Array.isArray(value) && value.length > 0) {
    const type = value[value.length - 1].conditionOneGroupType;
    const list = dicObj[type] || [];
    list.sort((a, b) => a.sort - b.sort);
    return list;
  }
  return [];
};
export const getDicListTwo = (data, dicObj, type) => {
  const valueFieldIds = data.valueFieldIds,
    value = data.operationType;
  if (
    valueFieldIds &&
    Array.isArray(valueFieldIds) &&
    valueFieldIds.length > 0
  ) {
    const typeTwo = valueFieldIds[valueFieldIds.length - 1][type].split(',');
    const typeThree = valueFieldIds[valueFieldIds.length - 1][type];
    let list = [];
    if (type === 'conditionThreeGroupType') {
      list = dicObj[typeThree] || [];
    } else if (value === 3) {
      list = dicObj[typeTwo[0]];
    } else if (value === 4) {
      list = dicObj[typeTwo[1]];
    }
    list.sort((a, b) => a.sort - b.sort);
    return list;
  }
  return [];
};

// eslint-disable-next-line no-unused-vars
export const checkTypeStatus = (value) => {
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1];
    return v;
  }
  return false;
};
// eslint-disable-next-line no-unused-vars
export const checkTypeStatusTwo = (value) => {
  //判断是否是时间类型，
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1].conditionTwoGroupType;
    return v && v !== null ? v.split(',') : '';
  }
  return false;
};

// eslint-disable-next-line no-unused-vars
export const checkTypeStatusThree = (value) => {
  //判断非时间是否是选择框
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1].fileType;
    return v && v !== null ? v : false;
  }
  return false;
};
// eslint-disable-next-line no-unused-vars
export const checkConditionOneGroupType = (value) => {
  //判断非时间是否是选择框
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1].conditionOneGroupType;
    return v && v !== null ? v : false;
  }
  return false;
};

export const checkForm = (data, errors) => {
  let status = false;
  data.forEach((item) => {
    if (item.withinItem) {
      item.withinItem.forEach((it) => {
        it.originalDataList.forEach((i) => {
          for (let x in i) {
            if (errors && x !== 'remark' && errors[`${x}-${i.id}`]) {
              status = true;
              break;
            }
          }
        });
      });
    }
  });
  return status;
};

//获取接口返回的选择项
export const getFetchList = (value, data) => {
  let list = [];
  if (value && Array.isArray(value) && value.length > 0 && data) {
    const type = value[value.length - 1].fileCodeEnumGroupType;
    data.forEach((item) => {
      if (item.labelGroup === type) {
        list = item.valueAndLabelList;
        return;
      }
    });
  }
  return list;
};

//判断是集合还是统计
export const haveFileCodeEnumGroupType = (value) => {
  //判断非时间是否是选择框
  if (value && Array.isArray(value) && value.length > 0) {
    const v = value[value.length - 1].fileCodeEnumGroupType;
    return v;
  }
  return false;
};

//保存数据的时候处理条件数据
export const getFormData = (list, tagId) => {
  let profileGroupRule = [];
  if (list.length > 0) {
    list.forEach((item) => {
      if (!tagId || typeof item.id !== 'number') {
        item.id = null;
      }
      if (item.tagCollectionRuleIn) {
        item.tagCollectionRuleIn.forEach((ite) => {
          if (!tagId || typeof ite.id !== 'number') {
            ite.id = null;
          }
          if (ite.withinItem) {
            ite.withinItem.forEach((i) => {
              if (i.originalDataList) {
                i.originalDataList.forEach((x) => {
                  delete x.profileTagCollectionId;
                  delete x.profileTagId;
                  delete x.collectArr;
                  if (!tagId || typeof x.id !== 'number') {
                    x.id = null;
                  }
                  if (x.originalDataType === 1) {
                    x.operationAnd = x.operationAnd ? x.operationAnd : null;
                  } else {
                    x.operation = 3;
                  }
                  x.ruleType = x.tagIds[x.tagIds.length - 1].ruleType;
                  x.tagIds = x.tagIds?.map((y) => y.id) || [];
                });
              }
              if (!tagId || typeof i.id !== 'number') {
                i.id = null;
              }
            });
          }
        });
        profileGroupRule.push({
          type: 1,
          outsideData: item.tagCollectionRuleIn,
        });
      }
      if (item.tagCollectionRuleOut) {
        item.tagCollectionRuleOut.forEach((ite) => {
          if (!tagId || typeof ite.id !== 'number') {
            ite.id = null;
          }
          if (ite.withinItem) {
            ite.withinItem.forEach((i) => {
              if (i.originalDataList) {
                i.originalDataList.forEach((x) => {
                  delete x.profileTagCollectionId;
                  delete x.profileTagId;
                  delete x.collectArr;
                  if (!tagId || typeof x.id !== 'number') {
                    x.id = null;
                  }
                  if (x.originalDataType === 1) {
                    x.operationAnd = x.operationAnd ? x.operationAnd : null;
                  } else {
                    x.operation = 3;
                  }
                  x.ruleType = x.tagIds[x.tagIds.length - 1].ruleType;
                  x.tagIds = x.tagIds?.map((y) => y.id) || [];
                });
              }
              if (!tagId || typeof i.id !== 'number') {
                i.id = null;
              }
            });
          }
        });
        profileGroupRule.push({
          type: 2,
          outsideData: item.tagCollectionRuleOut,
        });
      }
    });
  }
  return profileGroupRule;
};

const getIndex = (list, attr) => {
  for (let i = 0; i < list.length; i++) {
    if (list[i].id === attr) {
      return i;
    }
  }
  return -1;
};

export const filterTreeTags = (list) => {
  let arr = JSON.parse(JSON.stringify(list));
  function filterFun(data) {
    for (let i of data) {
      if (i.type === 7 && i.children && i.children.length === 0) {
        const index = getIndex(data, i.id);
        data.splice(index, 1);
        filterFun(data);
      } else {
        i.children && i.children.length > 0 && filterFun(i.children);
      }
    }
  }
  filterFun(arr);
  return arr;
};

export const ISHAVEAVALUE = 1; //有值
export const NOHAVEAVALUE = 2; //无值
export const ISRELATIVE = 3; //绝对
export const ISABSOLUTE = 4; //相对
export const ISBEFORE = 3; //之前
export const ISAFTER = 4; //之后
